import React from 'react';
import DemoDashboard from '../demo/DemoDashboard';

const LiteDashboard = ({ user, onLogout }) => {
  return <DemoDashboard user={user} onLogout={onLogout} isDemoMode={true} routeNamespace="lite" />;
};

export default LiteDashboard;
